import type { OpisKolumny } from '@/lib/raporty-api';

/**
 * WYBÓR KOLUMN RAPORTU — dwie reguły, które muszą dać się sprawdzić testem.
 *
 * ⚠️ WYJĘTE Z KOMPONENTU, BO OBIE PSUJĄ SIĘ CICHO. Zapamiętany zestaw z kolumną, której już nie ma,
 * kończy się ODMOWĄ SERWERA — czyli człowiek dostaje błąd za coś, co zapamiętaliśmy mu sami.
 * A przestawianie kolejności poza zakres listy albo zgubiłoby kolumnę, albo powtórzyło ją dwa razy,
 * i jedno i drugie widać dopiero w pliku.
 */

/**
 * Zestaw, z którym otwieramy okno: zapamiętany, a w jego braku domyślny z serwera.
 *
 * ⚠️ ZAPAMIĘTANY PRZESIEWAMY PRZEZ KATALOG. Kolumna mogła zniknąć albo zmienić klucz między
 * wydaniami; wysłanie nieznanego klucza to odmowa serwera (i słusznie — patrz `wybierzKolumny`
 * w API). Przesiewamy, zamiast czyścić pamięć: zestaw z jedną nieistniejącą kolumną nie może
 * kosztować całego wyboru.
 *
 * ⚠️ NIGDY NIE ODDAJEMY PUSTEJ LISTY. Okno z zerem zaznaczonych kolumn wygląda na zepsute,
 * a nie na „wybierz sobie" — więc gdy z zapamiętanego nie zostało nic, wracamy do domyślnych.
 */
export function zestawStartowy(
  katalog: readonly OpisKolumny[],
  domyslne: readonly string[],
  zapamietane: readonly string[] | null,
): string[] {
  const znane = new Set(katalog.map((k) => k.klucz));
  const przesiane = (zapamietane ?? []).filter((k) => znane.has(k));
  /** Powtórki też odsiewamy — serwer odmawia przy zdublowanym kluczu, a to nie życzenie, tylko śmieć. */
  const bezPowtorek = przesiane.filter((k, i) => przesiane.indexOf(k) === i);
  return bezPowtorek.length > 0 ? bezPowtorek : [...domyslne];
}

/**
 * Przestawienie jednej pozycji o `o` miejsc.
 *
 * ⚠️ POZA ZAKRESEM ZWRACAMY LISTĘ BEZ ZMIAN, zamiast zawijać na drugi koniec. Zawijanie sprawia,
 * że przycisk „wyżej" na pierwszej pozycji przenosi kolumnę na koniec pliku — ruch, którego nikt
 * nie chciał, a wygląda jak zgubiona kolumna.
 */
export function przestaw(lista: readonly string[], i: number, o: number): string[] {
  const j = i + o;
  if (i < 0 || i >= lista.length || j < 0 || j >= lista.length) return [...lista];
  const kopia = [...lista];
  [kopia[i], kopia[j]] = [kopia[j]!, kopia[i]!];
  return kopia;
}
